import api from "../axiosIntercepture";

export const getallfacility = async (page, pageSize) => {
    try {
        const response = await api.post(`facility/fetch?limit=${pageSize}&page=${page+1}`,);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const getallfacilitySelect = async (userData) => {
    try {
        const response = await api.post("facility/fetch-select",);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const createFacility = async (userData) => {
    try {
        const response = await api.post("facility/create", userData);
        return response.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}



export const updateFacility = async (asnId, payload) => {
    if (!asnId) throw new Error("Missing identifier for update Facility");

    try {
        const encoded = encodeURIComponent(asnId);
        const response = await api.post(`facility/update/${encoded}`, payload);

        // Try to be flexible with different API shapes
        if (response.data?.success && response.data?.data) {
            return response.data.data;
        }
        if (response.data) {
            return response.data;
        }

        return response;
    } catch (err) {
        console.error("Error updating Facility:", err);

        let errorMessage = "Failed to update Facility";
        if (err.response?.data?.message) {
            errorMessage = err.response.data.message;
        } else if (err.message) {
            errorMessage = err.message;
        }

        // small heuristics / helpful guidance (optional)
        if (errorMessage.toLowerCase().includes("facility")) {
            errorMessage = `${errorMessage}`;
        }

        throw new Error(errorMessage);
    }
};


export const searchFacility = async (inputValue) => {
    try {
        const response = await api.post(`facility/search?q=${inputValue}`,);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}

export const fetchFacilityByList = async () => {
    try {
        const response = await api.post("facility/fetch-by-list");
        console.log("response", response);
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}